import { InteractionStatus } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router'

import { isNotNull, logger } from '@hcr/utils'

import { REFERRER } from '../../../configs'
import { AccountSearchParamsKeys, Path } from '../../../models'

export const clearInteractionStatus = (): void => {
  const itemKey = 'msal.interaction.status'
  if (sessionStorage.getItem(itemKey)) {
    sessionStorage.removeItem(itemKey)
  }
}

export const useRelogin = (): void => {
  const [searchParams] = useSearchParams()
  const nonceSearchParam = searchParams.get(AccountSearchParamsKeys.Nonce)
  const reloginSearchParam = searchParams.get(AccountSearchParamsKeys.Relogin)
  const referrerSearchParam = searchParams.get(AccountSearchParamsKeys.Ref)

  const { instance, accounts, inProgress } = useMsal()

  useEffect(() => {
    const handleLogoutRedirect = async (): Promise<void> => {
      await instance.logoutRedirect({
        postLogoutRedirectUri: `${Path.Account}?${AccountSearchParamsKeys.Relogin}=true`,
      })
    }

    const handleLoginRedirect = async (): Promise<void> => {
      await instance.loginRedirect({
        redirectStartPage: `${Path.Account}?${AccountSearchParamsKeys.Status}=success`,
        scopes: [],
      })
    }

    const relogin = async (): Promise<void> => {
      try {
        clearInteractionStatus()

        if (inProgress !== InteractionStatus.None) {
          logger.warn('Interaction already in progress, skipping relogin.')
          return
        }

        if (accounts.length > 0 && isNotNull(nonceSearchParam)) {
          await handleLogoutRedirect()
        } else if (
          (isNotNull(reloginSearchParam) && accounts.length === 0) ||
          (isNotNull(nonceSearchParam) && accounts.length === 0)
        ) {
          await handleLoginRedirect()
        } else if (referrerSearchParam === REFERRER.WEBSHOP && accounts.length === 0) {
          await instance.loginRedirect()
        }
      } catch (error) {
        logger.error('Error during relogin:', error)
      }
    }

    void relogin()
  }, [nonceSearchParam, reloginSearchParam, referrerSearchParam, accounts, inProgress, instance])
}
